import {makeKey,update} from '../../../../utils/reducerOperations';
export function handleLoginProcessStarted(state, payload) {
    return makeKey(
        'loginProcessApi',
        update(state.loginProcessApi, {isProcessing: true})
    );
}